import { Monitor, Moon, Sun } from 'lucide-react';
import { useThemeStore, type Theme } from '@/stores/themeStore';
import { useTranslation } from 'react-i18next';

const OPTIONS: { value: Theme; icon: typeof Sun; labelKey: string }[] = [
  { value: 'light', icon: Sun, labelKey: 'common.light' },
  { value: 'dark', icon: Moon, labelKey: 'common.dark' },
  { value: 'system', icon: Monitor, labelKey: 'common.system' },
];

export function ThemeToggle() {
  const { theme, setTheme } = useThemeStore();
  const { t } = useTranslation();

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-border bg-card p-1"
      role="radiogroup"
      aria-label={t('common.theme')}
    >
      {OPTIONS.map(({ value, icon: Icon, labelKey }) => {
        const active = theme === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={t(labelKey)}
            onClick={() => setTheme(value)}
            className={
              'cursor-pointer rounded-full p-1.5 transition-all duration-300 ease-soft ' +
              (active
                ? 'bg-primary text-white shadow-soft'
                : 'text-muted hover:bg-faint hover:text-ink')
            }
          >
            <Icon size={16} />
          </button>
        );
      })}
    </div>
  );
}
